import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import ModalPersonas from 'components/molecules/ModalPersonas'
import ModalWindow from 'components/molecules/ModalWindow'
import { Outlet, useLocation } from 'react-router-dom'
import { Button, StackIcon } from 'shared/ui'

import { api } from '../../api'
import { useIsEnable, useSidebar } from '../../hooks'
import { Fallbacks } from '../Fallbacks/Fallbacks'
import { closeInvite, openInvite, useInviteModal } from './useInviteModal'

export function Wrapper() {
	const showMembers = useIsEnable()

	const query = api.usePersonasQuery(undefined, {
		skip: !showMembers
	})

	useSidebar()

	const isOpen = useInviteModal()

	return (
		<main className='main app-scroll'>
			<ModalWindow
				classes='invite-modal'
				closeHandler={closeInvite}
				open={isOpen}
			>
				<ModalPersonas
					getPersonas={query.refetch}
					setIsModalInvitedOpen={closeInvite}
				/>
			</ModalWindow>
			<Header />

			{query.isLoading && <FullLoader size={60} />}

			<Fallbacks />

			{query.isSuccess && <Outlet />}
		</main>
	)
}

function Header() {
	const { pathname } = useLocation()

	const showMembers = useIsEnable()

	if (pathname.includes('members') && showMembers) {
		return (
			<div className='flex-container-team-members'>
				<h2 className='teams-main-title-members'>Members</h2>

				<Button className='button-member' onClick={openInvite} type='button'>
					<StackIcon icon='plus' width={14} />
					Invite new member
				</Button>
			</div>
		)
	}

	if (pathname.includes('statistics')) {
		return <h2 className='teams-main-title'>Statistics</h2>
	}

	if (pathname.includes('invitations')) {
		return (
			<div className='flex-container-team-invitation'>
				<h2 className='teams-main-title-invitation'>Pending invites</h2>
			</div>
		)
	}

	return null
}
